export const TRANING_TYPES = {
  CORPORATE: 'corporate',
  KIDS: 'kids',
  TECHNOLOGIES: 'technologies',
};
